module.exports = __webpack_public_path__ + "img/modos_web_logo.867c618f.png";